export const appendBrandFromRelatedProduct = (relatedBrands = [], product, brandOptions = []) => {
  if (!product?.brandId) {
    return relatedBrands
  }

  const brandMatch = brandOptions.find((brand) => brand.id === product.brandId)

  if (!brandMatch) {
    return relatedBrands
  }

  if (relatedBrands.some((brand) => brand.id === brandMatch.id)) {
    return relatedBrands
  }

  return [...relatedBrands, brandMatch]
}

export default appendBrandFromRelatedProduct
